export const GET_NOTE_REQUEST = "GET_NOTE_REQUEST";
export const GET_NOTE_RESPONSE = "GET_NOTE_RESPONSE";
export const UPDATE_NOTE_REQUEST = "UPDATE_NOTE_REQUEST";
export const UPDATE_NOTE_RESPONSE = "UPDATE_NOTE_RESPONSE";
export const CREATE_NOTE_REQUEST = "CREATE_NOTE_REQUEST";
export const CREATE_NOTE_RESPONSE = "CREATE_NOTE_RESPONSE";
export const DELETE_NOTE_REQUEST = "DELETE_NOTE_REQUEST";
